import InlineLabel from '../../../src/components/InlineLabel';

const LocalInlineLabel = InlineLabel;

export default LocalInlineLabel;
